import Rotas from './Rotas/Rotas';

function App() {            
    return (      
        <Rotas/>            
    );
}

export default App;
